<template>
  <div class="content">
    <!-- <div class="con-top">
      <div class="top-tex warp">
        
        <p class="tex-item" v-for="(item,index) in channelList" v-click="index" :key="index" @click="clickChannelItem(item)">{{item.categoryName}}</p>
      </div>
    </div> -->

    <div class="contener warp">
      <div class="leftNav">
        <p class="menu-title">帮助中心</p>
        <el-scrollbar wrap-class="scrollbar-wrapper">
          <el-menu
            :default-active="active"
            background-color="#fff"
            text-color="#000"
            active-text-color="#FF7800"
            :unique-opened="true"
            @open="handleOpen"
          >
            <menu-tree ref="child" :menuData="menuList"></menu-tree>
          </el-menu>
        </el-scrollbar>
      </div>

      <div class="rightCon">
        <Breadcrumb :firstTitle="mainTitle" />
        <el-main class="main-container">
          <div
            v-if="this.articleList.length > 1 && this.articleList[0].articleId"
          >
            <ul style="margin-left: 40px">
              <li
                class="articleList"
                v-for="(item, index) in this.articleList"
                @click="clickTitle(item)"
                :key="index"
              >
                {{ item.articleTitile }}
              </li>
            </ul>
          </div>
          <div v-else v-html="compiledMarkdown"></div>

          <!-- <div>{{mainData}}</div> -->
        </el-main>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./breadcrumb";
import MenuTree from "./menuTree";
import api from "@/api";
import { listSearchMixin } from "@/config/mixin";
import marked from "marked";
import { mapState } from "vuex";
var rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
export default {
  mixins: [listSearchMixin],
  components: {
    Breadcrumb,
    MenuTree,
  },
  directives: {
    click: {
      inserted(el, binding, index) {
        if (binding.value === 0) {
          el.click();
        }
      },
    },
  },
  data() {
    return {
      active: "",
      flag: true,
      mainData: "",
      mainTitle: "",
      channelList: [],
      menuList: [],
    };
  },
  computed: {
    ...mapState({
      articleList: (state) => state.articleList,
    }),
    compiledMarkdown() {
      if (this.$store.state.articleList.length == 0) {
        return marked("", { sanitize: false });
      } else {
        if (this.$store.state.articleList[0]) {
          return marked(this.$store.state.articleList[0].detail, {
            sanitize: false,
          });
        } else {
          return marked("", { sanitize: false });
        }
      }
    },
  },
  watch: {
    compiledMarkdown(val) {
      this.mainData = val;
    },
  },
  beforeRouteUpdate(to, form, nxet) {
    this.active = to.query.categoryId;
    nxet();
    this.defaultOpen();
  },
  mounted() {
    this.active = this.$route.query.categoryId;
    this.getChannel();
    if (this.articleList.length == 0) {
      this.mainData = "";
    } else {
      if (this.articleList.length == 1) {
        this.mainData = this.articleList[0].detail;
      } else {
        this.articlList = this.articleList;
      }
    }
  },
  methods: {
    handleOpen(key) {
      this.recursion(key, this.menuList);
    },
    recursion(key, list) {
      list.forEach((item) => {
        if (item.categoryId == key) {
          this.active = String(item.children[0].categoryId);
          this.$refs.child.clickMenu(item.children[0]);
        } else {
          this.recursion(key, item.children);
        }
      });
    },
    clickTitle(item) {
      //调用vuex的selectMenu方法存储数据
      this.$store.commit("selectMenu", item);
      // this.$router.push({
      //   path:'/mainView?categoryId=' + item.categoryId,
      // })
      let self = this;
      let data = [];
      if (item.detail != "") {
        // console.log(item);
        data.push(item);

        this.$store.dispatch("selectAticle", data);
      } else {
        // console.log(111);
        self.$store.dispatch("selectAticle", [{ detail: "该文章下暂无内容" }]);
      }
      // let params = {
      //     url:api.getArticle + '/' + item.articleId,
      //     method:'POST'
      // };
      // self.sendReq(params,(res) => {
      //   if(res.code == 200){
      //     console.log(res.data)

      //     if(res.data.length!=0 && res.data[0].articleList){
      //       console.log(res.data[0].articleList)
      //     this.$store.dispatch('selectAticle', res.data[0].articleList)

      //     }else{
      //       console.log(111)
      //     self.$store.dispatch('selectAticle', [{detail:'该分类下暂无文章'}])

      //     }

      //   }
      // })
    },
    // 点击频道获取频道分类列表
    clickChannelItem(v) {
      // console.log(v);
      this.$store.commit("selectMenu", "");
      this.mainTitle = v.categoryName;
      this.menuList = v.children;
      let self = this;
      if (v.children && v.children[0].categoryId) {
        let params = {
          url: api.getArticle + "/" + v.children[0].categoryId,
          method: "POST",
        };
        self.sendReq(params, (res) => {
          if (res.code == 200) {
            // console.log(res.data);
            if (res.data.length != 0 && res.data[0].articleList) {
              // console.log(res.data[0].articleList);
              this.$store.dispatch("selectAticle", res.data[0].articleList);
            } else {
              // console.log(111)
              this.$store.dispatch("selectAticle", [
                { detail: "该分类下暂无文章" },
              ]);
              // console.log(this.$store.state.articleList);
            }
          }
        });
      }

      // let params = {
      //     url:api.channeData + '/' + v.categoryId,
      //     method:"POST"
      // };
      // self.sendReq(params,(res) => {
      //     if(res.code == 200){
      //       this.menuList = res.data;
      //     }
      // })
      // let self = this;
      // let params = {
      //     url:api.channeData + '/' + v.channelId,
      //     method:"POST"
      // };
      // self.sendReq(params,(res) => {
      //     if(res.code == 200){
      //       this.menuList = res.data;
      //     }
      // })
    },
    defaultOpen() {
      for (const object of this.menuList) {
        for (const item of object.children) {
          if (item.categoryId == this.active) {
            this.$refs.child.clickMenu(item);
          }
        }
      }
    },
    // 获取频道
    getChannel() {
      let self = this;
      let params = {
        url: api.channeData + "/" + 1,
        method: "POST",
      };
      self.sendReq(params, (res) => {
        if (res.code == 200) {
          this.menuList = res.data;
        }

        this.defaultOpen();
      });
      // let self = this;
      // let params = {
      //   url: api.channelList,
      //   method: "POST",
      //   data: {},
      // };
      // self.sendReq(params, (res) => {
      //     if(res.code == 200){
      //         this.channelList = res.data.list
      //     }
      // });
    },
  },
};
</script>

<style lang="scss">
.content {
  background: #f5f5f5;
  .con-top {
    min-height: 50px;
    background: #fff;
    border-top: 1px solid #f5f5f5;
    .top-tex {
      line-height: 50px;
      display: flex;
      flex-wrap: wrap;
      & :last-child {
        padding-right: 0 !important;
      }
      .tex-item {
        padding-right: 30px;
        cursor: pointer;
      }
    }
  }
  .contener {
    padding: 30px 0;
    height: auto;
    display: flex;
  }
  .leftNav {
    width: 300px;
    margin-right: 16px;
    background: #fff;
    // overflow: hidden;
    height: auto;
    .menu-title {
      color: #fff;
      font-weight: bold;
      background: #f77b0b;
      letter-spacing: 2px;
      line-height: 50px;
      text-align: center;
    }
  }
  .rightCon {
    background: #fff;
    width: calc(100% - 200px);
    .main-container {
      height: calc(100% - 50px);
      overflow: auto;
      img {
        width: 100%;
      }
      ::-webkit-scrollbar {
        display: none;
      }
    }
  }
}
.el-submenu__title {
  font-size: 18px;
  &:hover {
    color: #f77b0b !important;
    background-color: #fff !important;
  }
}
.articleList {
  margin: 20px 0;
  cursor: pointer;
  color: #606266;
  list-style-type: disc;
  &:hover {
    color: #f77b0b !important;
  }
}
.el-menu-item {
  color: #606266 !important;
  &.is-active {
    color: #f77b0b !important;
  }
  &:hover {
    color: #f77b0b !important;
    background-color: #fff !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/helpCenter/index.vue